import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {DataService} from '../data.service';
import { Observable, catchError} from 'rxjs';
import {CarrierContactInfo} from 'src/app/features/carrier-contact-info/carrier-contact-info';

@Injectable({
  providedIn: 'root'
})
export class CarrierContactInfoService extends DataService {
  private baseURI = this.apiUri + '/carriercontactinfo/';

  constructor(http: HttpClient) {
    super(http);
  }

  getAllCarrierContacts(carrierId): Observable<any> {
    return this.http.get(this.baseURI + carrierId + '/carrierid');
  }

  createupdateCarrierContact(contactInfo: CarrierContactInfo): Observable<any> {
    console.log(contactInfo);
    return this.http.post(this.baseURI + 'createupdate', contactInfo, {responseType: 'text'}).pipe(catchError(this.handleError));
  }
}
